const initialState ={
  csattemplate:[]
}

export default (state = initialState, action) => {
  switch (action.type) {
   case "CSAT_SEARCH_DATA":
    return Object.assign({}, state, {
      csatuserData: action.userData
   })
    case "CSAT_SEARCH_TEMPLATE":
      return Object.assign({}, state, {
       csattemplate: action.template
    }) 
    case "CSAT_SEARCH_COMPLETED":
      return Object.assign({}, state, {
        searchData: action.searchData
    }) 
    case "CSAT_ERROR":
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage
    })
    case "CSAT_MODAL_CLOSE":
      return Object.assign({}, state, {
        showerror: action.showerror
    }) 
    case "CSAT_SEARCH_TEMPLATE_RESET" :
    return Object.assign({}, state, {
      csattemplate: action.template
    })    
    case "CSAT_COMPLETED_SCORES":
      return Object.assign({}, state, {
        ScoreCalculation: action.ScoreCalculation
    })    
   default:
    return state
  }
 }

 